import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useMode } from "../lib/mode";

const TITLES = {
  mba: "PISA · MBA Simulation — The Weave",
  public: "PISA Decision Room — The Weave",
  member: "PISA · 1% Club — The Weave",
};

export default function ModeShell({ children }) {
  const { mode, config } = useMode();

  useEffect(() => {
    document.title = TITLES[mode] || TITLES.public;
  }, [mode]);

  return (
    <div className="min-h-screen w-full pisa-grain" data-testid="mode-shell" data-mode={mode}>
      {/* Top nav */}
      <header className="relative z-10 border-b border-[#E5E5E5]/70 bg-[#F9F9F7]/80 backdrop-blur-sm pisa-no-print">
        <div className="max-w-6xl mx-auto px-6 md:px-10 py-5 flex items-center justify-between">
          <Link to={mode === "mba" ? "/mba/pisa-decision-room" : mode === "member" ? "/member/pisa-decision-room" : "/decision-room"} className="flex items-center gap-4" data-testid="brand-link">
            <img
              src="https://customer-assets.emergentagent.com/job_pisa-think/artifacts/fruhhfsj_WEAVE-LOGO%202024.png"
              alt="The Weave"
              className="h-10 w-auto"
            />
            <div className="hidden sm:flex flex-col leading-tight pl-4 border-l border-[#E5E5E5]">
              <span className="text-[15px] font-medium text-[#1A1A1A]">PISA Decision Room</span>
              <span className="text-[11px] uppercase tracking-[0.18em] text-[#666666]" data-testid="mode-badge">{config.eyebrow}</span>
            </div>
          </Link>

          <nav className="flex items-center gap-2 sm:gap-3">
            {mode === "member" && (
              <a href="#" className="hidden sm:inline-flex text-sm text-[#666666] hover:text-[#1A1A1A] transition-colors px-3 py-2" data-testid="back-to-dashboard">← Back to your dashboard</a>
            )}
            {mode === "mba" && (
              <a href="#" className="hidden sm:inline-flex text-sm text-[#666666] hover:text-[#1A1A1A] transition-colors px-3 py-2" data-testid="return-to-sim">Return to simulation</a>
            )}
            {mode === "public" && (
              <a href="https://awake.wearetheweave.co.uk/join" target="_blank" rel="noopener noreferrer" className="hidden sm:inline-flex text-sm text-[#1A1A1A] border border-[#E5E5E5] rounded-full px-4 py-2 hover:bg-white transition-colors" data-testid="join-1pct-cta">Join the 1% Club</a>
            )}
          </nav>
        </div>
      </header>

      {/* Content */}
      <main className="relative z-10 max-w-6xl mx-auto px-6 md:px-10 py-10 md:py-16 pisa-print-area">
        {children}
      </main>

      {/* Footer */}
      <footer className="relative z-10 border-t border-[#E5E5E5]/70 mt-16 pisa-no-print">
        <div className="max-w-6xl mx-auto px-6 md:px-10 py-10 flex flex-col md:flex-row gap-6 md:items-center md:justify-between text-sm text-[#666666]">
          <p className="max-w-xl leading-relaxed" data-testid="footer-note">{config.footerNote}</p>
          <div className="flex items-center gap-4">
            <span className="text-xs uppercase tracking-[0.2em]">PISA</span>
            <span className="h-1 w-1 rounded-full bg-[#E5E5E5]" />
            <span className="text-xs">Pause · Inspect · Sense · Align</span>
            <span className="h-1 w-1 rounded-full bg-[#E5E5E5]" />
            <span className="text-xs">by <span className="text-[#1A1A1A]">The Weave</span></span>
          </div>
        </div>
      </footer>
    </div>
  );
}
